import { lnAssets } from './lnAssets';

/** Journal landing hero — bridge at sunset */
export const BLOG_INDEX_HERO = lnAssets.photos.servicesHeroBridge;

/** Who I Help photos — rotated across journal featured slots and article heroes */
export const WHO_HELP_IMAGES = [
  {
    id: 'couples',
    src: lnAssets.photos.whoHelpCouples,
    alt: 'Couple in a warm living room — marriage and couples counseling',
  },
  {
    id: 'individual',
    src: lnAssets.photos.whoHelpIndividual,
    alt: 'Person in a cozy armchair — individual therapy',
  },
  {
    id: 'family',
    src: lnAssets.photos.whoHelpFamily,
    alt: 'Family together on a couch — family counseling',
  },
  {
    id: 'workshops',
    src: lnAssets.photos.whoHelpWorkshops,
    alt: 'Diverse group in a circle — workshops and groups',
  },
] as const;

const WHO_HELP_SRCS = WHO_HELP_IMAGES.map((img) => img.src);

/** Prefer a photo that fits the article topic; fall back to slug rotation for even mix */
const TOPIC_IMAGE_INDEX: Record<string, number> = {
  Marriage: 0,
  Boundaries: 0,
  Parenting: 2,
  'Emotional health': 1,
  'Faith & purpose': 1,
  'Financial wellness': 1,
  'Transparent Tuesday': 1,
  Leadership: 3,
  'Team culture': 3,
  Communication: 3,
  'Retreats & events': 3,
};

function slugHash(slug: string, mod: number): number {
  let hash = 0;
  for (let i = 0; i < slug.length; i += 1) {
    hash = (hash + slug.charCodeAt(i) * (i + 1)) % mod;
  }
  return hash;
}

function imageIndexForPost(slug: string, topic?: string): number {
  const key = topic?.trim();
  if (key && key in TOPIC_IMAGE_INDEX) {
    return TOPIC_IMAGE_INDEX[key];
  }
  return slugHash(slug, WHO_HELP_SRCS.length);
}

/** Hero / featured image for a journal post */
export function getBlogPostImage(slug: string, topic?: string, explicit?: string): string {
  if (explicit?.trim()) return explicit.trim();
  return WHO_HELP_SRCS[imageIndexForPost(slug, topic)];
}

/** Accessible alt text matching the assigned Who I Help photo */
export function getBlogPostImageAlt(slug: string, topic?: string): string {
  const index = imageIndexForPost(slug, topic);
  return WHO_HELP_IMAGES[index]?.alt ?? 'Counseling and wellness';
}

/** @deprecated Use getBlogPostImage */
export function getArticleHeroImage(slug: string, explicit?: string): string {
  return getBlogPostImage(slug, undefined, explicit);
}
